import { EnvironmentConfigService } from './../environment/environment-config.service';
import * as i0 from "@angular/core";
import * as i1 from "../environment/environment-config.service";
// This api will come in the next version
export class AuthConfigService {
    constructor(environmentConfigService) {
        this.environmentConfigService = environmentConfigService;
        const config = this.environmentConfigService.getEnvironmentConfigs();
        const { flow, clientId, issuer } = config && config.sso;
        const currentLocation = window.location.origin;
        this._authConfig = {
            // Url of the Identity Provider
            issuer,
            // URL of the SPA to redirect the user to after login
            redirectUri: currentLocation,
            // URL of the SPA to redirect the user after silent refresh
            silentRefreshRedirectUri: `${currentLocation}/silent-refresh.html`,
            // The SPA's id. The SPA is registerd with this id at the auth-server
            clientId,
            // set the scope for the permissions the client should request
            // The first three are defined by OIDC. The 4th is a usecase-specific one
            scope: 'openid',
            // silentRefreshShowIFrame: true,
            showDebugInformation: true,
            sessionChecksEnabled: false,
            requireHttps: false,
            //responseType: 'id_token token',
            strictDiscoveryDocumentValidation: false,
            responseType: 'code',
            disableAtHashCheck: true,
            logoutUrl: `${issuer}/idp/startSLO.ping`
            // timeoutFactor: 0.01,
        };
        if (flow) {
            this._authConfig = Object.assign({}, this._authConfig, { customQueryParams: {
                    FLOW: flow
                } });
        }
    }
    get authConfig() {
        return this._authConfig;
    }
}
AuthConfigService.ngInjectableDef = i0.defineInjectable({ factory: function AuthConfigService_Factory() { return new AuthConfigService(i0.inject(i1.EnvironmentConfigService)); }, token: AuthConfigService, providedIn: "root" });
